import {
	FormControl,
	makeStyles,
	Typography,
	TextField,
	Chip
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import Autocomplete from '@material-ui/lab/Autocomplete';
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
	selectRoot: {
		borderRadius: 12,
		height: 44,
		paddingLeft: 12,
		backgroundColor:
			theme.palette.type === "dark"
				? "rgba(255, 255, 255, 0.06)"
				: "#fafafa",
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor:
				theme.palette.type === "dark"
					? "rgba(255, 255, 255, 0.24)"
					: "#e5e7eb"
		},
		"&:hover .MuiOutlinedInput-notchedOutline": {
			borderColor:
				theme.palette.type === "dark"
					? "rgba(255, 255, 255, 0.38)"
					: "#d1d5db"
		},
		"&.Mui-focused .MuiOutlinedInput-notchedOutline": {
			borderColor: theme.palette.type === "dark" ? "#4db6ac" : "#2563eb",
			borderWidth: 1
		}
	},
	label: {
		marginBottom: 6,
		color: theme.palette.text.secondary
	}
}));

export const FunnelSelect = ({ contact }) => {
	const classes = useStyles();
	const [salesFunnels, setSalesFunnels] = useState([]);
	const [funnels, setFunnels] = useState([{}]);
	const [alterFunnel, setAleterFunnel] = useState(false);
	const [selecteds, setSelecteds] = useState([]);
	const [filters, setFilters] = useState({
		salesFunnelId: undefined,
		salesFunnelColumnId: undefined
	});

	useEffect(() => {
		(async () => {
			try {
				const saleFunnel = await api.get("/sales-funnel");
				const salesfunnel = await Promise.all(
					saleFunnel.data.map(async (funnel) => {
						const { data } = await api.get("/sales-funnel/column", {
							params: {
								workspace: "contacts",
								salesFunnelId: funnel.id,
							},
						});

						return {
							...funnel,
							columns: data,
						};
					})
				);
				setSalesFunnels(salesfunnel);
				loadFunnels();
			} catch (error) {
				toastError(error);
			}
		})();
	}, []);

	useEffect(()=>{
		const funnelsOptions = salesFunnels.flatMap((funnel) =>
			funnel.columns.map((column) => ({
				idColumn: column.id,
				idFunnel: funnel.id,
				name: `${funnel.name} - ${column.name}`,
				color: column.cardColor
			})));
		setFunnels(funnelsOptions);
	},[salesFunnels])

	const handleCardMove = async (toSalesFunnelColumnsId,toSalesFunnelId) => {
		await api.post("/sales-funnel/pin-contact", {
			contactId: contact.id,
			salesFunnelColumnId: toSalesFunnelColumnsId,
			salesFunnelId: toSalesFunnelId
		});
	};

	const [selectedFunnel, setSelectedFunnel] = React.useState(contact?.funnels?.[0]?.FunnelContact?.salesFunnelId || "");

	const handleChangeFunnel = (value) => {

		setSelectedFunnel(value.idColumn);
		handleCardMove(value.idColumn,value.idFunnel);

		if (filters.salesFunnelId) {
			setSelecteds((prev) =>
				prev.map((item) =>
						item.salesFunnelColumnId === filters.salesFunnelColumnId
						? {
							...item,
							salesFunnelColumnId: value.idColumn,
							salesFunnelId: value.idFunnel,
							name: value.name,
							color: value.color
						}
						: item
				)
			);
			setFilters({
				salesFunnelId: undefined,
				salesFunnelColumnId: undefined
			});
		} else {
			setSelecteds((prev) => [
				...prev,
				{
					id: contact.id,
					salesFunnelColumnId: value.idColumn,
					salesFunnelId: value.idFunnel,
					name: value.name,
					color: value.color
				}
			])
		}
		setAleterFunnel(false);
	};

	const loadFunnels = async () => {
		const funnelsContact = contact?.funnels;
		if (!funnelsContact) return

		funnelsContact.forEach((funnel) => {
			setSelecteds((prev) =>
				[...prev,
					{
						id: funnel.FunnelContact.id,
						salesFunnelColumnId: funnel.FunnelContact.salesFunnelId,
						salesFunnelId: funnel.salesFunnel.id,
						name: `${funnel.salesFunnel.name} - ${funnel.name}`,
						color: funnel.cardColor
					}
				]);
		});
	};

	const filteredFunnels = (funnels ?? []).filter((funnel) => {
		if (!filters.salesFunnelId) {
			return !selecteds.some(
				(selected) => selected.salesFunnelId === funnel.idFunnel
			);
		}
		return (
			funnel.idFunnel === filters.salesFunnelId &&
			funnel.idColumn !== filters.salesFunnelColumnId
		);
	});

	const handleUnpin = async (v) => {
		try {
			await api.post("/sales-funnel/unpin-contact", {
				contactId: contact.id,
				salesFunnelColumnId: v.salesFunnelColumnId,
				salesFunnelId: v.salesFunnelId
			});
			setSelecteds((prev) =>
				prev.filter(
					(item) => item.salesFunnelColumnId !== v.salesFunnelColumnId
				)
			);
		} catch (error) {
			toastError(error)
		}
	};

	return (
		<div onMouseLeave={() => setAleterFunnel(false)}>
		<FormControl fullWidth style={{ padding: "25px 10px" }}>
			<div style={{ display: "flex", justifyContent: "space-between" }}>
				<Typography variant="subtitle2" className={classes.label}>
					Adicionar Funil de vendas
				</Typography>
				<button onClick={() => {
					setFilters({
						salesFunnelId: undefined,
						salesFunnelColumnId: undefined
					});
					setAleterFunnel(true);
				}}>
					<svg className="sf-header__btn-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" aria-hidden>
						<path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
					</svg>
				</button>
			</div>
			{selecteds.map((index) => (
				<Chip
					key={index.id}
					size="small"
					clickable
					label={index.name}
					onClick={() => {
						setFilters({
							salesFunnelId: index.salesFunnelId,
							salesFunnelColumnId: index.salesFunnelColumnId
						});
						setAleterFunnel(true);
					}}
					style={{
						backgroundColor: index.color || "#e0e0e0",
						color: "#fff",
						fontWeight: 500,
						cursor: "pointer",
						padding: "5px"
					}}
					onDelete={() => handleUnpin(index)}
					deleteIcon={<CloseIcon />}
				/>
			))}
			{alterFunnel && <Autocomplete
				size="medium"
				style={{padding:"10px"}}
				open={true}
				options={filteredFunnels}
				value={selectedFunnel}
				onChange={(e, v) => {
					if (!v) return
					handleChangeFunnel(v)
				}}
				getOptionLabel={(option) => option.name}
				className="w-full"
				renderInput={(params) => (
					<TextField
						{...params}
						variant="outlined"
						label="Funil de vendas"
						className="w-full"
					/>
				)}
				filterOptions={(options, { inputValue }) =>
					options.filter((option) =>
						option.name.toLowerCase().includes(inputValue.toLowerCase())
					)
				}
			/>}
		</FormControl>
		</div>
	);
};
